const GENERIC_HEADER_PATTERN = /^(?:\d+|col_\d+|unnamed(?::\s*\d+)?)$/i;

export const FEED_FORMAT_TYPE_VALUES = [
  "AUTO",
  "XML",
  "EXCEL",
  "CSV_COMMA",
  "CSV_COMMA_QUOTED",
  "CSV_SEMICOLON",
  "CSV_SEMICOLON_MULTILINE",
  "CSV_SEMICOLON_QUOTED",
  "CSV_TAB",
  "CSV_TAB_QUOTED",
  "CSV_PIPE",
  "CSV_PIPE_QUOTED",
  "CSV_PIPE_ENDRECORD",
];

export const formatFeedFormatOptionLabel = (type) => `FORMATO:${String(type || "AUTO").toUpperCase()}`;

export const SOURCE_TYPE_OPTIONS = FEED_FORMAT_TYPE_VALUES.map((value) => ({
  value,
  label: formatFeedFormatOptionLabel(value),
}));

export const HEADER_OPTIONS = [
  { value: "true", label: "HEADER:TRUE" },
  { value: "false", label: "HEADER:FALSE" },
];

export const GDRIVE_OPTIONS = [
  { value: "true", label: "G_DRIVE:TRUE" },
  { value: "false", label: "G_DRIVE:FALSE" },
];

export const isGenericFeedHeader = (label, column) => {
  if (!label || !String(label).trim()) {
    return true;
  }
  const normalized = String(label).trim().toLowerCase();
  if (normalized === String(column)) {
    return true;
  }
  return GENERIC_HEADER_PATTERN.test(normalized);
};

export const getFeedColumnLabel = (column, headerLabels = {}, isHeadless = false) => {
  if (isHeadless) {
    return `[${column}]`;
  }
  const raw = headerLabels?.[column];
  if (isGenericFeedHeader(raw, column)) {
    return `[${column}]`;
  }
  return `${raw} [${column}]`;
};

export const formatBytes = (bytes) => {
  if (!bytes) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
